// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3NEJD","large":"styles_large__vFw9s"};